const ValidationExportTypes = {
  WORKBOOK: "workbook",
  ERROR_LOG: "errorLog",
  ORIGINAL: "original"
};

export default ValidationExportTypes;
